import apiService from "./api";

const contractsService = {
  // Get all contracts for a single restaurant
  getRestaurantContracts(restaurantId) {
    return apiService.get(`/restaurants/${restaurantId}/contracts`);
  },
  // Create a new contract (with its price items) for a restaurant
  createRestaurantContract(restaurantId, payload) {
    return apiService.post(`/restaurants/${restaurantId}/contracts`, payload);
  },
  // Update limited contract fields (contract_number, valid_to, document_url, note)
  updateRestaurantContract(restaurantId, contractId, payload) {
    return apiService.put(`/restaurants/${restaurantId}/contracts/${contractId}`, payload);
  },
  // Global cross-restaurant worklist of expiring/expired/missing contracts
  getExpiringContracts(params) {
    return apiService.get("/contracts/expiring", params);
  },
};

export default contractsService;
